import axios from "axios";

const API_BASE_URL =
  process.env.REACT_APP_API_URL ||
  "https://interventi.synology.me:5050";

const getConfig = () => {
  const token =
    localStorage.getItem("token");

  return {
    headers: token
      ? {
          Authorization: `Bearer ${token}`,
        }
      : {},
    withCredentials: true,
  };
};

export const getFlottaDestination =
  async () => {
    const response = await axios.get(
      `${API_BASE_URL}/api/flotta/destinazione`,
      getConfig()
    );

    return response.data;
  };

export const setFlottaDestination =
  async (interventoId) => {
    const response = await axios.put(
      `${API_BASE_URL}/api/flotta/destinazione`,
      {
        interventoId,
      },
      getConfig()
    );

    return response.data;
  };

export const clearFlottaDestination =
  async () => {
    const response = await axios.delete(
      `${API_BASE_URL}/api/flotta/destinazione`,
      getConfig()
    );

    return response.data;
  };
